import styled from '@emotion/styled';

export const FormHeaderWrapper = styled('div', { label: 'FormHeaderWrapper' })`
    margin-bottom: 24px;
    display: flex;
    flex-flow: column nowrap;
    gap: 16px;
`;

export const Header = styled('header', { label: 'Header' })`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;
